import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

export function resolveUrl(url) {
  if (!url || typeof url !== "string") return "";
  if (url.startsWith("http://") || url.startsWith("https://") || url.startsWith("data:") || url.startsWith("blob:")) return url;
  if (url.startsWith("/api/uploads")) return `${BACKEND_URL}${url}`;
  if (url.startsWith("/uploads")) return `${BACKEND_URL}/api${url}`;
  if (url.startsWith("uploads/")) return `${BACKEND_URL}/api/${url}`;
  if (url.startsWith("api/uploads/")) return `${BACKEND_URL}/${url}`;
  if (url.startsWith("/")) return url;
  return `${BACKEND_URL}/api/uploads/${url}`;
}

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("portfolio_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
